export default "__VITE_ASSET__Cpp2$Lwb__"